(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-detail"] && !Shopify.designMode) return;
  try {
    
(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  function scrollToHashWithOffset() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var el = document.getElementById(hash.substring(1));
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var headerOffset = 120;
    var top = rect.top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(scrollToHashWithOffset, 50);
    });
  } else {
    setTimeout(scrollToHashWithOffset, 50);
  }
  window.addEventListener('load', function () {
    setTimeout(scrollToHashWithOffset, 100);
  });
  window.addEventListener('hashchange', function () {
    setTimeout(scrollToHashWithOffset, 50);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  function scrollToHashWithOffset() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var el = document.getElementById(hash.substring(1));
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var headerOffset = 120;
    var top = rect.top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(scrollToHashWithOffset, 50);
    });
  } else {
    setTimeout(scrollToHashWithOffset, 50);
  }
  window.addEventListener('load', function () {
    setTimeout(scrollToHashWithOffset, 100);
  });
  window.addEventListener('hashchange', function () {
    setTimeout(scrollToHashWithOffset, 50);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
